export default "__VITE_ASSET__DMVQn3gw__"